import { Tabs, Modal } from "antd";
import React, { useState } from "react";
import AcceptedCredential from "./acceptedCredential";
import AssignedCredential from "./assignedCredential";
import IgnoredCredential from "./ignoredCredentials";

const CredentialModal = ({ open, onCancel }) => {
  const [currentTab, setCurrentTab] = useState("1");

  const Storage = localStorage.getItem("details");
  const storedValue = JSON.parse(Storage);

  const items = [
    {
      key: "1",
      label: "Accepted",
      children: <AcceptedCredential checkGroupId={storedValue?.walletId} />,
    },
    {
      key: "2",
      label: "Assigned",
      children: <AssignedCredential checkGroupId={storedValue?.walletId} />,
    },
    {
      key: "3",
      label: "Ignored",
      children: <IgnoredCredential checkGroupId={storedValue?.walletId} />,
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      width="60%"
      centered
      style={{ top: 0 }}
      footer={null}
      title={
        <>
          <span>
            View credentials for{" "}
            <span style={{ color: "rgb(22, 119, 255)" }}>{storedValue?.mailId}</span>
          </span>
        </>
      }
    >
      <Tabs
        items={items}
        onChange={(key) => {
          setCurrentTab(key);
        }}
      />
    </Modal>
  );
};

export default CredentialModal;
